import { CommonStateEnum } from "./common";
import { OrderItemV2Ext, OrderV2 } from "./inventoryV2";
import { Product } from "./product";
import { User } from "./user";

interface BaseData {
  id: string;
  state: CommonStateEnum;
  createdAt: number;
  createdBy: string;
  updatedAt: number;
  updatedBy: string;
  creator: User | null;
  updater: User | null;

}
export enum PackOrderStatus {
  DRAFT,
  CONFIRMED,
  SHUTED,
  WASTED,
};

export enum BoxStatus {
  DRAFT,
  SHUTED,
}

export interface PackOrder extends BaseData {
  number: string;
  orgId: string;
  status: PackOrderStatus;
  sourceOrderId: string;
  sourceOrderNumber: string;
  shipmentOrderId: string;
  totalBoxes: number;
  totalGrossWeight: number;
  totalNetWeight: number;
  totalVolume: number;
  confirmedAt: number | null;
  sealedAt: number | null;
  voidedAt: number | null;
  remark: string;
  boxes: Array<PackBox> | null;
  inventoryOrders: OrderV2[] | null;
};


export interface PackSourceItemLot {
  lot: string;
  demandCount: number;
  packedCount: number;
  remainingCount: number;
  exts: OrderItemV2Ext;
}
export interface PackSourceItem {
  productId: string;
  product: Product;
  demandCount: number;
  packedCount: number;
  remainingCount: number;
  lots: Array<PackSourceItemLot>;
};


export enum PrintedEnum {
  PRINTED = 1,
  UN_PRINTED = 0
}

export interface PackBox {
  id: string;
  createdAt: number;
  boxNumber: string;
  boxSeq: number;
  barcode: string;
  status: BoxStatus;
  lengthMm: number;
  widthMm: number;
  heightMm: number;
  volumeCbm: number;
  grossWeightG: number;
  netWeightG: number;
  packageType: string;
  marksNumbers: string;
  labelPrinted: PrintedEnum;
  remark: string;
  items: Array<BoxItem>;
};

export interface BoxItem {
  id: string;
  createdAt: number;
  productId: string;
  product: Product;
  lot: string;
  count: number;
  uom: string;
  hsCode: string;
  originPlace: string;
  productNameCn: string;
  productNameEn: string;
  declaredUnitPrice: number;
  declaredCurrency: string;
  declaredAmount: number;
  remark: string;
  box: PackBox | null;
  order: PackOrder | null;
  brand: string;
  brandType: string;
  exportBrandName: string;
  docId: string | null;
  netWeight: number;
};

export interface BoxShipStatus {
  boxNumber: string;
  packingBoxId: string;
  shipmentOrderId: string | null;
  shipped: boolean;
}

export interface PackOrderAdd {
  orgId: string;
  sourceOrderId: string;
  sourceOrderNumber: string;
  shipmentOrderId: string;
  inventoryOrderIds: string[] | null;
  remark: string;
};

export interface AddPackBox {
  boxNumber?: string;
  lengthMm: number;
  widthMm: number;
  heightMm: number;
  grossWeightG?: number;
  netWeightG?: number;
  packageType?: string;
  marksNumbers?: string;
  remark?: string;
};

export interface AddPackBoxItem {
  productId: string;
  lot: string;
  count: number;
  declaredUnitPrice: number;
  declaredCurrency: string;
  hsCode: string;
  originPlace: string;
  productNameCn: string;
  productNameEn: string;
  remark: string;
  brand: string;
  brandType: string;
  exportBrandName: string;
  docId?: string;
  netWeight: number;
};
